import React, { useState, useEffect } from 'react';
import { Row, Col, CardBody, Input, Button, FormGroup, Label, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import APIClient from '../../../helpers/APIClient';
import Loader from '../../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../../constants/environment';
import { checkRole } from '../../../helpers/Roles';
import moment from 'moment';
import styled from 'styled-components';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import { cloneDeep, isEmpty } from 'lodash';
import IconEdit from '../../../assets/images/icon-edit.png';
import ModalPopup from '../../../components/ModalPopup';
import AddressAdd from './AddressAdd';
import _ from 'lodash';


const AddressChange = (props: any) => {
    const [users, setUser] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>({});
    const [address, setAddress] = useState<any>([])
    const { closeModal, action, onlyView, customer_id } = props
    const type = action?.type
    const [modalIsOpen, setIsOpen] = useState(false);
    const [actionChild, setActionChild] = useState<any>();

    const handleActionModal = (item: any) => {
        setActionChild(item)
        setIsOpen(true);
      }

    useEffect(() => {
        loadData()
    }, []);

    const loadData = async () => {
        const url = `${baseUrl}/customer/${customer_id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const dataTemp:any = {
                ...resData,
                provinces_code: {value: resData?.provinces_code?.code, code: resData?.provinces_code?.code, label: resData?.provinces_code?.name},
                district_code:{value: resData?.district_code?.code, code: resData?.district_code?.code, label: resData?.district_code?.name},
                wards_code:{value: resData?.wards_code?.code, code: resData?.wards_code?.code, label: resData?.wards_code?.name},
                source: {value: resData?.source},
            }
            setData(dataTemp)
            setAddress(resData?.address || [])
            props.setAddress(resData?.address || [])
        }
    }
    
    const handleSetAddressDefault = (index:number) => {
        let newAddress:any = cloneDeep(address)
        newAddress = newAddress?.reduce((prev:any, item:any)=>{
            item.status = 0
            prev = [...prev, item]
            return prev
        },[])
        newAddress[index].status = 1
        setAddress([...newAddress])
    }

    const validationFrom = () => {
        if (isEmpty(data.name)) {
            toast.warning('Tên khách hàng không được để trống!');
            return false
        }
        if (isEmpty(data.phone)) {
            toast.warning('Số điện thoại không được để trống!');
            return false
        }
        if (!data.provinces_code) {
            toast.warning('Tỉnh/ Thành phố không được để trống!');
            return false
        }
        if (!data.district_code) {
            toast.warning('Quận/ Huyện không được để trống!');
            return false
        }
        if (!data.wards_code) {
            toast.warning('Phường/ Xã không được để trống!');
            return false
        }
        if (isEmpty(data.street)) {
            toast.warning('Địa chỉ chi tiết không được để trống!');
            return false
        }
        return true
    }
    
    const handleSave = async() => {
        const address_default = address?.filter((itemFil:any)=> itemFil?.status === 1)
        if(address_default && address_default[0]){
            const url = `${baseUrl}/customer/address-default/${customer_id}/${address_default[0]?.id}`;
            setLoading(true)
            let response: any = await APIClient.PUT(url, {});
            setLoading(false)
            if (response.error !== undefined) {
                toast.error(response.error.error_description)
            } else if (response.response !== undefined) {
                loadData()
                closeModal()
                toast.success('Thay đổi địa chỉ mặc định thành công')
            }
        }
       
    }

    if(!checkRole(props?.user?.roles, ['customerEdit', 'customerAdd'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }
    
    return (
        <CardBody className='p-0' style={{width: 750}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title"> Địa chỉ nhận hàng </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-2 pt-4">
                <PageContent className={onlyView ? 'only-view' : ''}>
                <div className='customer-address-container customer-address-change'>
                    {address?.map((item:any, index:number)=>{
                        return(
                            <div key={`address-${index}`} className='customer-address '>
                                <span className='add-default'>
                                    <div onClickCapture={()=>{
                                        item?.status !== 1 && handleSetAddressDefault(index)
                                    }} className={item?.status === 1 ? "nutri-radio active" : "nutri-radio"} onClick={() => type=='view' ? {} :setData({...data, type:'normal'}) }>
                                        <div className="icon"></div>
                                    </div>
                                </span>
                                <div className='add-content'>
                                    <div className='add-head'>
                                        <h3>{item?.name}</h3>
                                        <div className='add-action table-action'>
                                            <div className="btn-add-address" onClick={() => handleActionModal({data: item, index:index, type:'editAddress'})}>Cập nhật</div>
                                        </div>
                                    </div>
                                    <span className='add-info'>
                                        {item?.street ? `${item?.street}, ` : ""}
                                        {item?.wards_code?.name
                                            ?  `${item?.wards_code?.name}, `
                                            : ""}
                                    
                                        {item?.district_code?.name
                                            ?  `${item?.district_code?.name}, `
                                            : ""}
                                        
                                        {item?.provinces_code?.name
                                            ?  `${item?.provinces_code?.name}`
                                            : ""}    
                                    </span>
                                    <span className='add-phone'>{item?.phone}</span>
                                    <span className='add-default'>
                                        <span>{item?.status === 1 ? "Địa chỉ mặc định":""}</span>
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                </PageContent>
            </div>
            {action?.type !== 'view' &&
            <div className="modal-footer">
                <Button onClick={()=>{closeModal()}} className="ml-2 success-bland" color="success" type="button" >Hủy bỏ</Button>
                <Button onClick={()=>{handleSave()}} className="ml-2" color="success" type="button" >Xác nhận</Button>
            </div>}
            {loading && <Loader />}
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {actionChild?.type === 'editAddress' &&
                    <AddressAdd closeModal={() => setIsOpen(false)} action={actionChild} address={address} setAddress={(val:any)=>{
                        setAddress(val)
                        loadData()
                    }} updateRealTime={true} customer_id={customer_id} />
                }
                
            </ModalPopup>
        </CardBody>
    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`
const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(AddressChange)